<div class="markdown-single-line-wrapper">
  <textarea [id]="id" type="text" class="form-control" rows="1"
            [(ngModel)]="content"></textarea>
</div>
